import ForcedChange from './ForcedChange'
import VoluntaryChange from './VoluntaryChange'

const ChangePassword = ({ isVoluntary, ...props }) => isVoluntary ? (
  <VoluntaryChange {...props} />
) : (
  <ForcedChange {...props} />
)

export default ChangePassword
